/**
 * Get series from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const guidemeGQLQuery = (pathOrId) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`{
    RootsTechPageEntry(id: "${pathOrId}") {
      ... on OneOffPage {
        name
        content(site: "") {
          ... on ListModule {
            _viewTemplate
            ctaTarget
            ctaText
            ctaUrl
            title
            description
            items {
              date{
                timestamp
              }
              membersOnly
              objectTypeId
              title
              description
              contentUUID
              url
              type
              image {
                custom(height: ${imageSize}, width: ${imageSize} ) {
                  image {
                    src
                  }
                }
              }
              creators {
                name
                profilePhoto {
                  custom(height: ${imageSize}, width: ${imageSize}) {
                    image {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

}
  `)
}

export const seriesGQLQuery = (path) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`{
    RootsTechPageEntry(id: "${path}") {
        ... on Series {
          canonicalLink
          charset
          title
          description
          contentId
          keywords
          sections {
            title
            description
            items {
              date{
                timestamp
              }
              parentLocale
              locale
              membersOnly
              url
              type
              title
              membersOnly
              duration
                    description
              contentUUID
              objectTypeId
              collectionCount
              category
              image{
                custom(height: 250, width: 250) {
                  image {
                    src
                  }
                }
              }
              creators {
                profilePhoto {
                  custom(height: 250, width: 250) {
                    image {
                      src
                    }
                  }
                }
                name
              }
            }
          }
          overviewVideo {
            videoProvider {
              ... on YoutubeVideoProvider {
                providerType
                videoId
              }
            }
          }
          mainImage {
            custom(height: 250, width: 250) {
              image {
                src
              }
            }
          }
          downloadableResources {
            href
            title
            contentId
          }
          suggestedContent {
            title
            description
            url
            contentUUID
            objectTypeId
            image{
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                }
              }
            }
          }
          additionalExperiences {
            url
            title
            description
            objectTypeId
            image{
            custom(height: 250, width: 250) {
              image {
                src
              }
            }
            }
          }
        }
      }
}
  `)
}

export const dummy = () => {}
